import {
  sagaListSuccess,
  sagaOneSuccess,
  sagaUpdateSuccess,
  sagaCreateSuccess
} from "../actions/ActionTypes";

const ADMINS = "admins";
const ADMIN = "admin";
const initialState = { list: [], currentAdmin: {} };
export default function admins(state = initialState, action = {}) {
  switch (action.type) {
    case sagaListSuccess(ADMINS):
      return { ...state, list: action.data.data };
    case sagaOneSuccess(ADMIN):
      return { ...state, currentAdmin: action.data.data };
    case sagaCreateSuccess(ADMIN):
      return { ...state, currentAdmin: action.data.data };
    case sagaUpdateSuccess(ADMIN):
      return { ...state, currentAdmin: action.data.data };
    case "SAGA_CHANGE_ADMIN_PASSWORD_SUCCESS":
      return { ...state, currentAdmin: {} };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/admins.js